export default "__VITE_ASSET__DjG9h_CP__"